import { render, staticRenderFns } from "./HelpPhoneNumberPlacement.vue?vue&type=template&id=b4db5eb8&scoped=true"
var script = {}
import style0 from "./HelpPhoneNumberPlacement.vue?vue&type=style&index=0&id=b4db5eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4db5eb8",
  null
  
)

export default component.exports